<h1 class="modal__header">Update Beneficiaries</h1>
<div>
  <div class="modal__body">
    <div class="modal__text">Apply changes to one of the following policies:</div>
    <div class="radio-button">
      <input
        (click)="setSelection('Whole')"
        type="radio"
        class="radio-button__input"
        id="bene_whole_split_radio"
        name="bene_split_radio"
        value="Whole"
      />
      <label class="radio-button__label" for="bene_whole_split_radio">
        <div class="radio-button__description"></div>
        <div class="radio-button__description">{{ wlPolicyDescription }}</div>
      </label>
    </div>
    <div class="radio-button">
      <input
        (click)="setSelection('Term')"
        class="radio-button__input"
        id="bene_term_split_radio"
        name="bene_split_radio"
        type="radio"
        value="Term"
      />
      <label class="radio-button__label" for="bene_term_split_radio">
        <div class="radio-button__description"></div>
        <div class="radio-button__description">{{ termPolicyDescription }}</div>
      </label>
    </div>
  </div>

  <div class="modal__actions modal__actions--inline">
    <button
      class="button button--blue button--primary modal__button"
      [disabled]="!valueSelected()"
      (click)="submitJointDecision()"
    >
      Continue
    </button>
    <button class="button button--blue button--secondary button--no-border modal__button" (click)="exit()">
      Exit Now
    </button>
  </div>
</div>
